module.exports = __webpack_public_path__ + "static/img/3.43ed50c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/10/zh/3.png
// module id = jYke
// module chunks = 0